import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type CreateDeliveryOrderMutationVariables = Types.Exact<{
  order: Types.Delivery_Orders_Insert_Input;
}>;


export type CreateDeliveryOrderMutation = { __typename?: 'mutation_root', insert_delivery_orders_one?: { __typename?: 'delivery_orders', id: number, order_number: string, recipient_business: string } | null };

export type CreateDeliveryOrdersMutationVariables = Types.Exact<{
  orders: Array<Types.Delivery_Orders_Insert_Input> | Types.Delivery_Orders_Insert_Input;
}>;


export type CreateDeliveryOrdersMutation = { __typename?: 'mutation_root', insert_delivery_orders?: { __typename?: 'delivery_orders_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'delivery_orders', id: number, order_number: string, recipient_business: string }> } | null };


export const CreateDeliveryOrderDocument = gql`
    mutation createDeliveryOrder($order: delivery_orders_insert_input!) {
  insert_delivery_orders_one(object: $order) {
    id
    order_number
    recipient_business
  }
}
    `;
export type CreateDeliveryOrderMutationFn = Apollo.MutationFunction<CreateDeliveryOrderMutation, CreateDeliveryOrderMutationVariables>;

/**
 * __useCreateDeliveryOrderMutation__
 *
 * To run a mutation, you first call `useCreateDeliveryOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeliveryOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeliveryOrderMutation, { data, loading, error }] = useCreateDeliveryOrderMutation({
 *   variables: {
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCreateDeliveryOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeliveryOrderMutation, CreateDeliveryOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeliveryOrderMutation, CreateDeliveryOrderMutationVariables>(CreateDeliveryOrderDocument, options);
      }
export type CreateDeliveryOrderMutationHookResult = ReturnType<typeof useCreateDeliveryOrderMutation>;
export type CreateDeliveryOrderMutationResult = Apollo.MutationResult<CreateDeliveryOrderMutation>;
export type CreateDeliveryOrderMutationOptions = Apollo.BaseMutationOptions<CreateDeliveryOrderMutation, CreateDeliveryOrderMutationVariables>;
export const CreateDeliveryOrdersDocument = gql`
    mutation createDeliveryOrders($orders: [delivery_orders_insert_input!]!) {
  insert_delivery_orders(objects: $orders) {
    affected_rows
    returning {
      id
      order_number
      recipient_business
    }
  }
}
    `;
export type CreateDeliveryOrdersMutationFn = Apollo.MutationFunction<CreateDeliveryOrdersMutation, CreateDeliveryOrdersMutationVariables>;

/**
 * __useCreateDeliveryOrdersMutation__
 *
 * To run a mutation, you first call `useCreateDeliveryOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeliveryOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeliveryOrdersMutation, { data, loading, error }] = useCreateDeliveryOrdersMutation({
 *   variables: {
 *      orders: // value for 'orders'
 *   },
 * });
 */
export function useCreateDeliveryOrdersMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeliveryOrdersMutation, CreateDeliveryOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeliveryOrdersMutation, CreateDeliveryOrdersMutationVariables>(CreateDeliveryOrdersDocument, options);
      }
export type CreateDeliveryOrdersMutationHookResult = ReturnType<typeof useCreateDeliveryOrdersMutation>;
export type CreateDeliveryOrdersMutationResult = Apollo.MutationResult<CreateDeliveryOrdersMutation>;
export type CreateDeliveryOrdersMutationOptions = Apollo.BaseMutationOptions<CreateDeliveryOrdersMutation, CreateDeliveryOrdersMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/createDeliveryOrder.mutation.gql}
 */
export async function createDeliveryOrder(
  variables: CreateDeliveryOrderMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<CreateDeliveryOrderMutation['insert_delivery_orders_one']>
export async function createDeliveryOrder(
  variables: CreateDeliveryOrderMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<CreateDeliveryOrderMutation>
export async function createDeliveryOrder(
  variables: CreateDeliveryOrderMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<CreateDeliveryOrderMutation['insert_delivery_orders_one'] | CreateDeliveryOrderMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<CreateDeliveryOrderMutation>(
    CreateDeliveryOrderDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_delivery_orders_one
}

/**
 * @source {@link src/features/partsDelivery/queries/createDeliveryOrder.mutation.gql}
 */
export async function createDeliveryOrders(
  variables: CreateDeliveryOrdersMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<CreateDeliveryOrdersMutation['insert_delivery_orders']>
export async function createDeliveryOrders(
  variables: CreateDeliveryOrdersMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<CreateDeliveryOrdersMutation>
export async function createDeliveryOrders(
  variables: CreateDeliveryOrdersMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<CreateDeliveryOrdersMutation['insert_delivery_orders'] | CreateDeliveryOrdersMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<CreateDeliveryOrdersMutation>(
    CreateDeliveryOrdersDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_delivery_orders
}